import styled from 'styled-components';

type Props = {
  label: string;
  num?: number;
  checked: boolean;
  disabled?: boolean;
  setChecked: (checked: boolean) => void;
};
export const ChkInput = ({ label, num, checked, disabled, setChecked }: Props) => {
  return (
    <Body>
      <label className='flex items-center cursor-pointer'>
        <Chk type='checkbox' checked={checked} disabled={disabled} onChange={(e) => setChecked(e.target.checked)} />
        <span>{label}</span>
        {num && <span className='num'>{num}</span>}
      </label>
    </Body>
  );
};

const Chk = styled.input`
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 0.4rem;
  border: 1px solid #97a4c8;
  margin-right: 0.8rem;
  cursor: pointer;
  appearance: none;
  background-color: #fff;

  &:checked {
    background-color: #2a5caa;
    border-color: #2a5caa;
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
  }

  &:disabled {
    background-color: #c7d6ea;
    border-color: #c7d6ea;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(42, 92, 170, 0.3);
  }
`;

const Body = styled.div`
  display: flex;
  align-items: center;
  padding: 0.4rem;
  color: #2a2c2f;
  min-height: 3.2rem;
  flex-wrap: wrap;
  line-height: 1.4rem;

  & span.num {
    padding-left: 0.4rem;
    font-size: 1.4rem;
    font-weight: 700;
    color: #c7d6ea;
    font-size: 1.2rem;
  }
`;
